<template>
  <div class="user-profile">
    <Header propsTitle="회원가입" @clickBack="$emit('clickBack')" />

    <div class="container">
      <div id="userDetail" class="page-inner">
        <Stepper step="3" />

        <v-form ref="form">
          <CommonForm ref="refCommonForm" :userData="userData" />

          <!-- 버튼 처리 -->
          <div class="bottom-btn mt-10">
            <v-btn
              v-if="userData.signupPath !== 'kakao'"
              color="primary"
              x-large
              outlined
              block
              rounded
              class="mb-3"
              @click="clickCancel"
              >이전으로</v-btn
            >
            <v-btn
              color="primary"
              x-large
              depressed
              block
              rounded
              @click="clickSave"
            >
              가입하기
            </v-btn>
          </div>
        </v-form>
      </div>
    </div>
    <ConfirmDialog ref="refConfirmDialog" @clickOk="clickPopupConfirm" />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Header from "./common/Header.vue";
import Stepper from "./agree/Stepper.vue";
import CommonForm from "./CommonForm.vue";
const modelService = require("@/utils/dataModel.js");
const rulesService = require("@/utils/rules.js");
import ConfirmDialog from "@/_bayer/commonComp/dialog/ConfirmDialog.vue";

export default {
  components: {
    Header,
    Stepper,
    CommonForm,
    ConfirmDialog,
  },
  props: {
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      emailIdRules: rulesService.emailIdRules(),
    };
  },
  computed: {
    ...mapGetters(["isDev", "isAuthorized"]),
  },
  methods: {
    clickSave() {
      // 필수체크
      const $h = this.$helper;
      const DT = this.userData;
      const RF = this.$refs;
      const objRF = RF.refCommonForm.$refs;
      // console.log(DT);

      // 회원가입시
      // if (!this.isAuthorized && !DT.checkSms) {
      //   $h.showTostMessage("", "[인증번호 받기]를 선택해주세요", "info");
      //   return;
      // }

      // if (!this.isAuthorized && DT.checkSms && !DT.checkedSms) {
      //   $h.showTostMessage("", "[인증완료]를 선택해주세요", "info");
      //   return;
      // }

      // 휴대전화가번호가 안오는경우 안내
      let msg = `휴대전화번호가 없습니다.`;
      if (!$h.requiredCheck(DT.cell, null, msg, false)) return;

      if (!RF.form.validate()) {
        console.log("RF.form.validate() 에러");
        return;
      }
      let tObj = null;
      msg = `연령대를 선택해주세요`;
      if (!$h.requiredCheck(DT.birthdayType, null, msg, false)) return;

      console.log(
        "this.emailIdRules.check2(DT.emailId)",
        this.emailIdRules.check2(DT.emailId)
      );

      if (DT.emailId !== "" && !this.emailIdRules.check2(DT.emailId)) {
        msg = `올바른 이메일 형식이 아닙니다.`;
        $h.showTostMessage("", msg, "error");
        objRF.refUserForm.$refs.refEmailForm.$refs.refEmailId.focus();
        return;
      }

      if (DT.emailDomain !== "" && !this.emailIdRules.check2(DT.emailDomain)) {
        msg = `올바른 이메일 형식이 아닙니다.`;
        $h.showTostMessage("", msg, "error");
        objRF.refUserForm.$refs.refEmailForm.$refs.refEmailDomain.focus();
        return;
      }

      msg = `자택주소를 검색 해주세요`;
      console.log("DT", DT);
      if (!this.isAuthorized && !DT.isAddressSearch) {
        $h.showTostMessage("", msg, "info");
        objRF.refAddress.$refs.refZipcode.focus();
        return;
      }

      msg = `자택주소 상세주소를 입력해주세요 해주세요`;
      tObj = objRF.refAddress.$refs.refStreet;
      if (!$h.requiredCheck(DT.address.street, tObj, msg)) return;

      msg = `주요 재배 작물(1)과 재배면적을 입력해 주세요`;
      tObj = objRF.refFarmForm.$refs.refCropsFrom1.$refs.refCrops;
      if (!$h.requiredCheck(DT.farm.crops1, tObj, msg)) return;

      tObj = objRF.refFarmForm.$refs.refCropsFrom1.$refs.refCropArea;
      if (!$h.requiredCheck(DT.farm.areaSize1, tObj, msg)) return;

      msg = `주요 재배 작물(2)과 재배면적을 입력해 주세요`;
      tObj = objRF.refFarmForm.$refs.refCropsFrom2.$refs.refCrops;
      if (!$h.requiredCheck(DT.farm.crops2, tObj, msg)) return;

      tObj = objRF.refFarmForm.$refs.refCropsFrom2.$refs.refCropArea;
      if (!$h.requiredCheck(DT.farm.areaSize2, tObj, msg)) return;

      DT.email = DT.emailId + "@" + DT.emailDomain;
      console.log("DT", DT);
      // return;
      // if (!confirm("회원가입하시겠습니까?")) return;
      this.$refs.refConfirmDialog.open("회원가입하시겠습니까?");
    },
    clickPopupConfirm() {
      this.$emit("prepareSignUp");
    },
    clickCancel() {
      this.$emit("clickCancel");
    },
    scrollTop() {
      const scrollTarget = document.getElementById("userDetail");
      scrollTarget.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss">
.user-profile {
  // padding: 8rem 0 12rem;
  .section-inner {
    max-width: 800px;
    width: 65vw;
  }

  .section-header {
    padding: 0 1rem 2.5rem;
    text-align: center;

    .input-guide {
      margin-top: 1.5rem;
      //color: $primary-color;
    }
  }

  .row {
    margin: 0;

    .col {
      padding: 0;

      .v-btn {
        min-width: calc(100% - 10px);
        padding: 0;
        margin-left: 10px;
      }
    }
  }

  .v-btn-toggle {
    width: 100%;
    margin-bottom: 30px;

    .v-btn {
      width: 50%;
    }
  }

  .bottom-wrap {
    margin: 5rem 0 1rem;

    .v-btn--block {
      display: inline-flex;
      min-width: initial !important;
      width: calc(50% - 6px);

      &:last-child {
        margin-left: 12px;
      }
    }
  }
}

@media (max-width: 768px) {
  div.user-profile {
    padding: 0;

    .row-cell {
      .col-9 {
        flex: 0 0 60%;
        max-width: 60%;
      }

      .col-3 {
        flex: 0 0 40%;
        max-width: 40%;
      }
    }

    .row-code {
      flex-direction: column;
      margin-bottom: 24px;

      .col {
        max-width: 100%;

        .v-btn {
          min-width: 100%;
          margin-left: 0;
        }
      }
    }

    .bottom-wrap {
      .v-btn--block {
        display: flex;
        min-width: 100% !important;

        &:last-child {
          margin-left: 0;
          margin-top: 12px;
        }
      }
    }
  }
}
</style>